import React from "react";
import T from "./../TheTool";

function InputBag(props) {

    
    var label1 = T.getValue(props.label, ""); 
    var labelSize = T.getValue(props.labelSize, 28); 
    var numOnly = T.getValue(props.numOnly, false); 
	return (
		<form>
			<div style={{ alignItems: "center" }}>
				<label style={{ fontSize: labelSize, paddingRight: 20 }}>
					<b>{label1}</b>
				</label>
				<input
					type="text"
					id="input_boxsize"
					className="input input__001"
					name="text"
					autoComplete="off"
					// textAlign={"center"}
					style={{
						fontSize: 32,
						textAlign: "center",
						// color:'blue'
						width: 200
					}}
					// defaultValue={10}
					value={props.value}
				    onChange={(event) => props.valueChange(event.target.value)}
					onKeyPress={(event) => {
						if (numOnly && !/[0-9]/.test(event.key)) {
						  event.preventDefault();
						}
					  }}
				/>
			</div>
		</form>
	);
}

export default InputBag;
